/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap')
import Vue from 'vue'
window.Vue = require('vue');

Vue.component(
    'table-component',
    require('./components/TableComponent.vue').default
)

Vue.component(
    'fixture-component',
    require('./components/FixtureComponent.vue').default
)

Vue.component(
    'fixture-list-component',
    require('./components/FixtureListComponent.vue').default
)

Vue.component(
    'message-component',
    require('./components/MessageComponent.vue').default
)

Vue.component(
    'team-list-component',
    require('./components/TeamListComponent.vue').default
)

Vue.component(
    'team-list-item-component',
    require('./components/TeamListItemComponent.vue').default
)

Vue.component(
    'player-list-component',
    require('./components/PlayerListComponent.vue').default
)

Vue.component(
    'player-list-item-component',
    require('./components/PlayerListItemComponent.vue').default
)

Vue.component(
    'commentary-list-component',
    require('./components/CommentaryListComponent.vue').default
)

Vue.component(
    'commentary-list-item-component',
    require('./components/CommentaryListItemComponent.vue').default
)

Vue.component(
    'score-component',
    require('./components/ScoreComponent.vue').default
)

Vue.component(
    'result-prediction-component',
    require('./components/ResultPredictionComponent.vue').default
)

Vue.component(
    'landingpage-preference-component',
    require('./components/LandingPagePreferenceComponent.vue').default
)

Vue.component(
    'yourteam-notification-component',
    require('./components/YourTeamNotificationComponent.vue').default
)

Vue.component(
    'fixture-notification-component',
    require('./components/FixtureNotificationComponent.vue').default
)

Vue.component(
    'fixture-notification-bell-component',
    require('./components/FixtureNotificationBellComponent.vue').default
)

Vue.component(
    'language-switcher-component',
    require('./components/LanguageSwitcherComponent.vue').default
)

const optaApp = new Vue({el: '#opta-app'});
if (window.location.pathname !== '/login') {
    const optaHeaderApp = new Vue({el: '#header'});
    const optaSidebarApp = new Vue({el: '#menu'});
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
        .then(function (reg) {
            // successfully registered
        }).catch(function (err) {
    });
}

require('@pm-connect/mixpanel-product')
